import {Component, HostBinding, OnInit} from '@angular/core';
import {AttachmentService} from "../../../../../services/attachment.service";

@Component({
  selector: 'app-attachment-url-upload',
  templateUrl: './attachment-url-upload.component.html',
  styleUrls: ['./attachment-url-upload.component.scss'],
  standalone: false,
})
export class AttachmentUrlUploadComponent implements OnInit {
  @HostBinding('className') componentClass: string;

  constructor(private attachmentService: AttachmentService) {
    this.componentClass = 'h-100 w-100';
  }

  ngOnInit(): void {}

  addnewLink() {
    this.attachmentService.linkUploadMode.next(true);
  }
}
